import {
  ColumnHeader,
  CondensedPagination,
  GridSelectAllCheckbox,
  Spinner,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
  useGridForm,
} from "@qw/ui";
import { useInboxQueryStates } from "@/providers/inbox-query-states-provider";
import { useConversations } from "@/providers/use-conversations";
import { MiniAppToggle } from "../app/mini-app-toggle";
import { InboxBulkActions } from "./inbox-bulk-actions";
import { InboxRefreshButton } from "./inbox-refresh-button";

export const InboxSelectionHeader = () => {
  const { loading, refetch } = useConversations();
  const { conversationId } = useInboxQueryStates();
  const { hasSelection } = useGridForm();

  return (
    <ColumnHeader icon={loading ? <Spinner /> : <SelectAllConversationsCheckbox />} className="pr-2">
      {hasSelection ? (
        <InboxBulkActions />
      ) : (
        <>
          <InboxRefreshButton onRefreshComplete={refetch} />
          <div className="ml-auto flex items-center gap-1">
            <CondensedPagination label="Conversations" loading={loading} />
            {!conversationId && <MiniAppToggle />}
          </div>
        </>
      )}
    </ColumnHeader>
  );
};

// `GridSelectAllCheckbox` renders through `FieldBase`, which drops unknown props, so the
// tooltip's pointer handlers need a plain element of their own to land on.
const SelectAllConversationsCheckbox = () => (
  <Tooltip>
    <TooltipTrigger asChild>
      <span className="flex">
        <GridSelectAllCheckbox inputProps={{ "aria-label": "Select all conversations" }} />
      </span>
    </TooltipTrigger>
    <TooltipContent>Select all conversations</TooltipContent>
  </Tooltip>
);
